import { FaqComponent } from'./faq.component';

export const routes = [{ path: '', component: FaqComponent }];